import { ProcedureSets } from '../types/Procedure';

import { baseApi } from './baseApi';

export const procedureApi = baseApi
  .enhanceEndpoints({ addTagTypes: [
    'Patient',
    'ApplicationEvents',
    'Education',
    'Survey',
    'TrackerInstance',
    'TrackerInstances',
    'Threads',
  ] })
  .injectEndpoints({
    endpoints: (builder) => ({
      getProcedureSets: builder.query<ProcedureSets[], void>({
        query: () => 'api/v4/episodes',
      }),
      setProcedureSet: builder.mutation<ProcedureSets[], { device?: string }>({
        query: (params) => {
          return {
            url: 'api/v4/episodes/set_selected',
            method: 'POST',
            body: params,
          };
        },
        invalidatesTags: [
          'Patient',
          'ApplicationEvents',
          'Education',
          'Survey',
          'TrackerInstance',
          'TrackerInstances',
          'Threads',
        ],
      }),
    }),
    overrideExisting: false,
  });

// Export hooks for usage in function components, which are
// auto-generated based on the defined endpoints
export const {
  useGetProcedureSetsQuery,
  useSetProcedureSetMutation,
} = procedureApi;
